import { cn } from '@/lib/cn';
import type { EventStatus, Totals } from '@lib/care-model';

/**
 * StatusTabs - ClariCommand chip row for the queue status filter. Counts come from the corrected
 * server totals (computed over the direction/search-scoped set, NOT the status-filtered set), so each
 * chip shows its true bucket size regardless of which tab is active.
 */

export type TabKey = EventStatus | 'all';

export interface TabDef {
  key: TabKey;
  label: string;
}

export interface StatusTabsProps {
  tabs: TabDef[];
  active: TabKey;
  totals?: Totals | undefined;
  onSelect: (key: TabKey) => void;
}

export function StatusTabs({ tabs, active, totals, onSelect }: StatusTabsProps) {
  const countFor = (k: TabKey): number | undefined => {
    if (!totals || k === 'all') return undefined;
    const v = totals[k as keyof Totals];
    return typeof v === 'number' ? v : undefined; // bySource is not a tab count
  };
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {tabs.map((t) => {
        const count = countFor(t.key);
        return (
          <button
            key={t.key}
            type="button"
            className={cn('chip', t.key === active && 'selected')}
            onClick={() => onSelect(t.key)}
          >
            {t.label}
            {count !== undefined ? ` (${count})` : ''}
          </button>
        );
      })}
    </div>
  );
}
